export const NAVBAR_BLOCK_s11 = {
  "blockType": "NAVBAR",
  "blockDesign": "NavDesign1",
  "editFormName": "NAVBAR_FORM_1",
  "styleProps": {
    "background-color": "#D0ECF5",
    "padding": "14px 0px 14px 0px"
  },
  "logoType": "text",
  "logoImg": {
    "src": "https://freshflowxyz.b-cdn.net/assets/logo/FlexBee-Logo-1.jpg",
    "altText": "FlexBee",
    "styleProps": {
      "height": "3rem"
    }
  },
  "logoText": {
    "text": "✪ Qonic",
    "styleProps": {
      "font-size": "1.875rem",
      "color": "#333333",
      "font-family": "'Nunito', sans-serif",
      "line-height": "2.25rem",
      "font-family-bk": "'Nunito', sans-serif",
      "font-weight": "900",
      "font-family-cust": ""
    },
    "stylePropsMob": {},
    "stylePropsTab": {}
  },
  "logoHTML": {
    "html": "FlexBee",
    "styleProps": {
      "font-size": "1.875rem",
      "color": "#ffffff",
      "font-family": "'Oswald', sans-serif",
      "line-height": "2.25rem"
    },
    "stylePropsMob": {},
    "stylePropsTab": {}
  },
  "links": [
    {
      "text": "Features",
      "linkUrl": "/features",
      "styleProps": {
        "color": ""
      },
      "sectionID": "aboutsection"
    },
    {
      "text": "Services",
      "linkUrl": "/services",
      "styleProps": {
        "color": ""
      },
      "sectionID": "aboutsection"
    },
    {
      "text": "Docs",
      "linkUrl": "/docs",
      "styleProps": {
        "color": ""
      },
      "sectionID": "aboutsection"
    },
    {
      "text": "Blog",
      "linkUrl": "/home",
      "sectionID": "aboutsection",
      "styleProps": {
        "color": "",
        "margin": "0px 0px 0px 120px"
      }
    },
    {
      "text": "Get Started",
      "linkUrl": "/home",
      "sectionID": "aboutsection",
      "styleProps": {
        "color": "#333333",
        "border-width": "0px",
        "border-radius": "0px",
        "padding": "20px 30px 20px 30px",
        "margin": "0px 0px 0px 20px",
        "border-color": "#4f4f4f",
        "background-color": "#EEFAFE",
        "font-weight": "600"
      }
    }
  ],
  "hamburgerStyleProps": {
    "color": "#333333",
    "border-color": "#333333"
  },
  "metaDataId": 1746278821165,
  "afterIndex": 8,
  "blockId": 1746278821165,
  "linksStyleProps": {
    "color": "#333333",
    "padding": "14px 0px 14px 0px",
    "font-weight": "600",
    "font-size": "1rem",
    "line-height": "1.5rem"
  },
  "fonts": {
    "logoText": ""
  }
}